//URL parameter helper function
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function compatibilityClearContainer(callback) {
    compatibilityHeader.fadeOut();
    $('html, body').animate({
        scrollTop: ($('.page-header').first().offset().top - 50)
    }, 500);

    compatibilityContainer.fadeOut(200, function () {
        compatibilityContainer.empty();
        $("#compatibilityChartLoading").css("display", "block");
        compatibilityHeader.empty();
        callback();
    });
}

function compatibilityShowContainer() {
    compatibilityContainer.fadeIn(200);
    compatibilityHeader.fadeIn();
}


function compatibilityAddSearchBox() {
    compatibilityHeader.append($("#compatibilitySearchBoxTemplate").html());
    $("#compatibility_search_form").submit(function (e) {
        e.preventDefault();
        var query = $("#compatibility_search_field").val();
        if (query.length > 0)
            compatibilityLoadData(compatibilityEndpoint + '/series/search/' + query);
        else {

        }
    });
}

function compatibilityAddBackButton(breadcrumbs) {
    if (typeof(breadcrumbs) != "undefined") {
        if (breadcrumbs.length > 0) {
            var breadcrumb_html = '<div class="col-xs-12"><ol class="breadcrumb">';
            var breadcrumb_link = '';
            for (var f = 0; f < breadcrumbs.length; f++) {
                if (breadcrumbs[f].is_active != true) {
                    breadcrumb_link = '<li><a data-src="' + breadcrumbs[f].url + '" class="breadcrumbButton" data-href="' + breadcrumbs[f].loc + '" href="' + breadcrumbs[f].loc + '">' + breadcrumbs[f].name + '</a></li>';
                }
                else {
                    breadcrumb_link = '<li class="active">' + breadcrumbs[f].name + '</li>';
                }
                breadcrumb_html += breadcrumb_link
            }
            compatibilityHeader.append(breadcrumb_html);
            $(".breadcrumbButton").click(function (e) {
                e.preventDefault();
                if ($(this).attr('data-src') != 'undefined') {
                    history.pushState({url: '?dt=' + $(this).attr('data-href')}, "", $(this).attr('data-href'));
                    compatibilityLoadData($(this).attr('data-src'));
                }
            });
        }
    }
}

function compatibilityLoadData(xhref) {
    if (is_loading == false) {
        is_loading = true;

        compatibilityClearContainer(function () {
            $.getJSON(xhref, function (data) {
                if (data.result == true) {
                    $("#compatibilityChartLoading").css("display", "none");
                    // Back button
                    compatibilityAddBackButton(data.breadcrumbs);
                    // Defining templates
                    switch (data.template) {
                        case "LoadDetails":
                            compatibilityContainer.append(compatibilityParseDetails(data));
                            $(".compatible-details-switch-btn").click(function (e) {
                                e.preventDefault();
                                $("#compatible-details-switch li").removeClass("active");
                                $(this).parent().addClass("active");
                                var target_tab = $('#' + $(this).attr('data-src'));
                                $("#tabs_container>div").fadeOut(100).promise().done(function () {
                                    target_tab.fadeIn();
                                });

                            });
                            break;
                        case "LoadSeries":
                            compatibilityAddSearchBox();
                            compatibilityContainer.append(compatibilityParseSeries(data));
                            $(".compatibilityProductTypeDetailsButton").click(function () {
                                history.pushState({url: xhref}, "", '?dt=' + $(this).attr('data-field-name'));
                                compatibilityLoadData($(this).attr('data-src'));
                            });
                            break;
                        default:
                            compatibilityAddSearchBox();
                            compatibilityContainer.append(compatibilityParseTypes(data));
                            $(".compatibilityProductTypeDetailsButton").click(function () {
                                history.pushState({url: xhref}, "", '?dt=' + $(this).attr('data-field-name'));
                                compatibilityLoadData($(this).attr('data-src'));
                            });
                    }

                    compatibilityShowContainer();
                }
            });
            is_loading = false;
        });
    }
}

function compatibilityParseDetails(data) {
    var template = $("#compatibilityProductSeriesDetailsTemplate").html();
    //Basics
    template = template.replace('[NAME]', data.name)
        .replace('[IMAGE_URL]', data.image_url)
        .replace(/\[PAGE_URL]/g, data.pdp_url)
        .replace('[KEYWORDS]', 'Models: ' + data.keywords);
    // Apps
    var a = 0, b = 0, c = 0;
    if (data.apps.length > 0) {
        var app_template = $("#compatibilityProductAppsListTemplate").html();
        var app_list = "";
        var app_thumb = "";
        for (a = 0; a < data.apps.length; a++) {
            app_list += app_template.replace('[NAME]', data.apps[a].name)
                .replace('[IMAGE_URL]', data.apps[a].image_url)
                .replace('[OS_VERSION_REQUIREMENT]', data.apps[a].os_version_requirement)
                .replace(/\[DOWNLOAD_URL]/g, data.apps[a].download_url)
                .replace('[DOWNLOAD_NAME]', data.apps[a].download_name)
                .replace('[APP_VERSION]', data.apps[a].os_version)
                .replace(/\[OS_TYPE]/g, data.apps[a].os_type)
                .replace('[FEATURES]', data.apps[a].features)
                .replace('[SUPPORT_RESOURCE_URL]', data.apps[a].support_resource_url);
            app_thumb += '<a class="app_thumb_"' + data.apps[a].os_type + ' title="' + data.apps[a].os_type + '"><span class="label label-primary"><i class="fas fa-check-circle"></i>&nbsp;' + data.apps[a].os_type + '</span></a>&nbsp;';
        }


        template = template.replace('[APPS]', app_list);
        template = template.replace('[APP_THUMBS]', app_thumb);
    }
    else {
        template = template.replace('[APPS]', "<div class='col-xs-12'><div class='alert alert-danger'>No supported applications</div></div>");
        template = template.replace('[APP_THUMBS]', "");
    }


    // Series
    if (data.series.length > 0) {
        var series_template = $("#compatibilityProductRelatedTemplate").html();
        var series_list = "";
        for (b = 0; b < data.series.length; b++) {

            series_list += series_template.replace('[NAME]', data.series[b].name)
                .replace('[IMAGE_URL]', data.series[b].image_url)
                .replace('[TYPE]', data.series[b].type)
                .replace(/\[PDP_URL]/g, data.series[b].pdp_url)
                .replace(/\[CTA]/g, data.series[b].pivot.custom_is_compatible_text)
                .replace(/\[custom_cta_url]/g, data.series[b].pivot.custom_cta_url)
                .replace(/\[custom_cta]/g, data.series[b].pivot.custom_cta)
                .replace(/\[custom_disclaimer]/g, data.series[b].pivot.custom_disclaimer);

        }

        template = template.replace('[SERIES]', series_list);
    }
    else {
        template = template.replace('[SERIES]', "<div class='col-xs-12'><div class='alert alert-danger'>No supported products</div></div>");
    }
    template = template.replace('[NUM_APPS]', a);
    if (a <= 0) {
        template = template.replace('[NUM_APPS_STYLE]', 'display:none');
    } else {
        template = template.replace('[NUM_APPS_STYLE]', 'display:inherit');
    }

    template = template.replace('[NUM_SERIES]', b);

    // Documents

    if (data.documents.length > 0) {
        var documents_template = $("#compatibilityDocumentsTemplate").html();
        var documents_list = "";
        for (c = 0; c < data.documents.length; c++) {
            documents_list += documents_template.replace(/\[DOC_URL]/g, data.documents[c].url)
                .replace(/\[DOC_NAME]/g, data.documents[c].name);

        }
        template = template.replace('[DOCUMENTS]', documents_list);
    }
    template = template.replace('[NUM_DOCUMENTS]', c);
    if (c <= 0) {
        template = template.replace('[NUM_DOCUMENTS_STYLE]', 'display:none');
    } else {
        template = template.replace('[NUM_DOCUMENTS_STYLE]', 'display:inherit');
    }
    return template;
}

function compatibilityParseSeries(data) {

    var template_html = '';
    if (data.total > 0) {
        for (var i = 0; i < data.total; i++) {

            var template = $("#compatibilityProductSeriesTemplate").html();
            template = template.replace('[NAME]', data.series[i].name)
                .replace('[TOTAL]', data.series[i].total)
                .replace('[IMAGE_URL]', data.series[i].image_url)
                .replace(/\[PAGE_URL]/g, data.series[i].pdp_url)
                .replace(/\[COMPATIBILITY_URL]/g, data.series[i].compatibility_url)
                .replace(/\[DATA_NAME]/g, data.series[i].type + '&dp=' + data.series[i].id);
            if (i % 2 == 0 && i > 0) {
                template_html += '<div class="w-100"></div>';
            }
            template_html += template;

        }
    }
    else {
        template_html = '<div class="col-xs-3 center"><div class="alert alert-info" role="alert"><strong>No results<strong></div></div>';
    }
    return template_html;
}

function compatibilityParseTypes(data) {
    var template_html = '';

    for (var i = 0; i < data.groups.length; i++) {
        template_html += '<div class="col-xs-12"><h2 class="h3 compcategory">' + data.groups[i].title + '</h2></div>';
        for (var k = 0; k < data.groups[i].categories.length; k++) {

            var template = $("#compatibilityProductTypesTemplate").html();
            template = template
                .replace('[NAME]', data.groups[i].categories[k].name)
                .replace('[CLASS_NAME]', data.groups[i].categories[k].name.replace(" ", "_"))
                .replace('[TOTAL]', data.groups[i].categories[k].total)
                .replace('[IMAGE_URL]', data.groups[i].categories[k].image)
                .replace(/\[PAGE_URL]/g, data.groups[i].categories[k].url)
                .replace(/\[DATA_NAME]/g, data.groups[i].categories[k].name);
            if (k % 4 == 3 && k > 0) {
                compatibilityContainer.append('<div class="clearfix"></div>');
            }
            template_html += template;
        }
    }
    return template_html

}


var compatibilityContainer = $("#compatibilityChartContainer");
var compatibilityHeader = $("#compatibilityChartHeader");
var compatibilityEndpoint = 'https://lorexreviews.com/api/v2/product';
var is_loading = false;
var dp = getUrlParameter('dp');
var dt = getUrlParameter('dt');

$("document").ready(function () {
    if (typeof(dp) != 'undefined') {
        //data point url present
        compatibilityLoadData(compatibilityEndpoint + '/compatibility/' + dp);
    }
    else {
        if (typeof(dt) != 'undefined') {
            compatibilityLoadData(compatibilityEndpoint + '/series/type/' + dt);
        }
        else {
            compatibilityLoadData(compatibilityEndpoint + '/series/types');
        }
    }
    window.addEventListener('popstate', function (e) {
        e.preventDefault();
        location.reload();
    });
});